import { PlayCircleOutlined } from '@ant-design/icons';
import { message, Modal, Tooltip, Typography } from 'antd';
import {
  InfrastructureInstance,
  InfrastructureInstanceActionsEnum,
} from 'osep-generator-service-client-v1';
import { useState } from 'react';
import usePerformInfrastructureInstanceActionMutation from '../hooks/mutations/usePerformInfrastructureInstanceActionMutation';

type Props = {
  instance: InfrastructureInstance;
};

const ProvisionInfraProjectInstanceButton = ({ instance }: Props) => {
  const { performInfrastructureInstanceAction } =
    usePerformInfrastructureInstanceActionMutation();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    setIsLoading(true);
    try {
      await performInfrastructureInstanceAction(instance.id, {
        action: InfrastructureInstanceActionsEnum.Provision,
      });
      setIsModalVisible(false);
      message.success(
        "We will provision the instance for you and notify you via email once it's ready.",
      );
    } catch (error) {
      message.error(
        `There was an error while provisioning the instance. Please try again or contact the OSEP team.`,
      );
      console.error('Error when provisioning instance:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Tooltip title={'Provision'}>
        <PlayCircleOutlined key="delete" onClick={showModal} />
      </Tooltip>
      <Modal
        title={'Provision Instance'}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={'Provision'}
        cancelText="Cancel"
        confirmLoading={isLoading}
      >
        <Typography.Paragraph>
          Do you want to provision instance <b>{instance.name}</b>?
        </Typography.Paragraph>
      </Modal>
    </>
  );
};

export default ProvisionInfraProjectInstanceButton;
